import { Command } from 'commander';

export function formatVaultGuide(): string {
    return [
        'Jai1 Vault là gì?',
        '',
        'Jai1 Vault là kho lưu trữ mã hóa E2E cho server, app context, runbook, prompt, instruction, note và secret.',
        'CLI là nơi duy nhất xử lý plaintext. Jai1 server chỉ sync encrypted blobs, nên server không thể đọc hoặc khôi phục nội dung gốc.',
        '',
        'Khi nào dùng Vault?',
        '- Khi bạn muốn nhờ coding agent SSH vào server nhưng không muốn paste thông tin nhạy cảm vào chat.',
        '- Khi bạn muốn lưu context project/infra để lần sau agent hiểu nhanh hệ thống.',
        '- Khi bạn muốn lưu prompt, instruction hoặc runbook để tái sử dụng theo tag/keyword.',
        '- Khi bạn cần backup encrypted vault lên Jai1 server và khôi phục trên máy mới.',
        '',
        'Khởi tạo lần đầu:',
        '1. Chạy `j vault init`.',
        '2. Đọc cảnh báo recovery và nhập passphrase.',
        '3. Lưu recovery key vào password manager hoặc nơi offline an toàn.',
        '4. Chạy `j vault trust` trên máy cá nhân để lần sau không cần nhập lại passphrase.',
        '5. Chạy `j vault sync --push` để backup encrypted data lên Jai1 server.',
        '',
        'Alias ngắn:',
        '- `j v` là alias của `j vault`, ví dụ `j v list`, `j v ssh-ro mira-prod pm2 status`.',
        '',
        'ID dễ nhớ:',
        '- Vault dùng slug từ title làm ID, không thêm hash ngẫu nhiên. Ví dụ `mira-prod` giữ nguyên là `mira-prod`.',
        '- Nếu ID bị trùng, CLI sẽ báo lỗi để bạn chọn title/ID khác thay vì tự thêm suffix.',
        '- `j vault list` hoặc `j v list` hiển thị bảng dễ đọc để bạn copy ID thủ công.',
        '',
        'Các vault type:',
        '- server: thông tin máy chủ để agent/operator tra cứu hoặc SSH qua `j vault ssh-ro`/`j vault ssh`.',
        '  Ví dụ: VPS production, devtest server, bastion host, database host.',
        '- app: thông tin ứng dụng chạy trên server hoặc trong project.',
        '  Ví dụ: path deploy, PM2 process name, port, health URL, env file location.',
        '- context: tài liệu Markdown mô tả tổng quan hệ thống, infra, cấu trúc project.',
        '  Ví dụ: kiến trúc Mirabot, danh sách service, môi trường dev/staging/prod.',
        '- runbook: hướng dẫn thao tác theo từng bước cho vận hành/debug/deploy.',
        '  Ví dụ: hướng dẫn deploy, restart worker, rollback, kiểm tra log lỗi.',
        '- prompt: prompt có thể tái sử dụng cho agent.',
        '  Ví dụ: prompt review PR, prompt phân tích incident, prompt tạo report.',
        '- instruction: quy tắc hoặc hướng dẫn agent/human cần tuân thủ.',
        '  Ví dụ: cách làm việc với repo này, quy định deploy, chuẩn viết report.',
        '- note: ghi chú tự do, ít cấu trúc hơn context/runbook.',
        '  Ví dụ: quyết định kỹ thuật, ghi chú meeting, checklist tạm.',
        '- secret: giá trị nhạy cảm cần giữ kín.',
        '  Ví dụ: token, password, API key, private endpoint, SSH credential.',
        '',
        'Sensitivity là gì?',
        '- public: thông tin ít nhạy cảm.',
        '- internal: thông tin nội bộ, dùng làm mặc định.',
        '- secret: mức độ nhạy cảm nghiệp vụ. Riêng quyền xem full được quản lý bằng flag contains-secret.',
        '',
        'Flag chứa secret:',
        '- Mặc định mọi item mới được xem là có chứa secret để an toàn.',
        '- Nếu biết chắc nội dung không có secret, tạo bằng `--no-secret` để `show` và `reveal` có thể in full mà không cần `--reason`.',
        '- Có thể đổi sau bằng `j v update <id> --no-secret` hoặc `j v update <id> --secret`.',
        '- Nếu item vẫn chứa secret, muốn xem plaintext thì dùng `j v reveal <id> --reason "<lý do>"`.',
        '',
        'Ví dụ lưu server:',
        '```bash',
        'j vault add server --title mirabot-devtest \\',
        '  --field host=47.79.126.202 \\',
        '  --field user=root \\',
        '  --field port=22 \\',
        '  --field appUser=mira-bot \\',
        '  --sensitivity secret \\',
        '  --tag mirabot --tag devtest --tag server',
        '```',
        '',
        'Ví dụ lưu server qua bastion:',
        '```bash',
        'j v add server --title coc-bastion --field host=<public-ip> --field user=ubuntu --no-secret',
        'j v add server --title coc-redis --field host=10.20.30.4 --field user=ubuntu --field bastion=coc-bastion --no-secret',
        'j v ssh-ro coc-redis "sudo ss -tnp | grep :6379"',
        '```',
        '',
        'Ví dụ lưu runbook Markdown:',
        '```bash',
        'j vault add runbook --title "Mirabot deploy" --file docs/runbooks/mirabot-deploy.md --tag deploy --no-secret',
        'j v show mirabot-deploy',
        '```',
        '',
        'Tìm và dùng với agent:',
        '```bash',
        'j vault search "deploy" --project',
        'j v list',
        'j vault render <id> --agent --with-refs',
        'j v update <id> --no-secret',
        'j vault ssh-ro <server-id> pm2 status',
        'j vault ssh-ro <server-id> "sudo journalctl -u app -n 100"',
        'j vault ssh <server-id> --reason "deploy requested by user" "sudo systemctl restart app"',
        'j vault ssh-as <server-id> mira-bot pm2 status',
        'j v ssh-as mira-prod mira-bot pm2 status',
        '```',
        '',
        'Refs trong Markdown:',
        '- Có thể tham chiếu item khác bằng `[[server:prod-api]]`, `[[app:web]]`, `[[runbook:deploy-prod]]`, `[[secret:prod-token]]`.',
        '- Khi render cho agent, non-secret refs có thể được resolve bằng `--with-refs`.',
        '- secret refs không tự bung; agent chỉ thấy placeholder rằng secret đang được lưu trong vault.',
        '',
        'Khôi phục trên máy mới:',
        '```bash',
        'j auth',
        'j vault sync --pull',
        'j vault list --recovery-key "<recovery-key>"',
        'j vault trust',
        '```',
        '',
        'Nguyên tắc an toàn:',
        '- Không lưu recovery key trong repo, chat history hoặc file plaintext của project.',
        '- Không paste secret vào prompt nếu có thể dùng `j vault render`, `j vault ssh-ro`, `j vault ssh` hoặc command vault-backed.',
        '- Dùng `j vault ssh-ro <server-id> <command...>` cho điều tra mặc định; lệnh có nguy cơ sửa server sẽ bị chặn trước khi SSH.',
        '- Dùng `j vault ssh` hoặc `j vault ssh-as` khi user thật sự yêu cầu execution mode có thể thay đổi state.',
        '- Dùng `j vault search "..." --project` khi hỏi về "project này".',
        '- Dùng `j vault reveal <id> --reason "<lý do>"` khi item còn được đánh dấu là chứa secret.',
    ].join('\n');
}

export function createVaultGuideCommand(): Command {
    return new Command('guide')
        .description('Show Vietnamese usage guide for Jai1 Vault')
        .action(() => {
            console.log(formatVaultGuide());
        });
}
